import { httpService } from 'core-utilities';
import experimentConstants from '../constants/experimentConstants';
import recommendationsModule from '../recommendationsModule';

function experimentationService() {
  return {
    getABTestEnrollment(projectId, layerName, parameters) {
      return httpService.get(
        experimentConstants.url.getExperimentationValues(projectId, layerName, parameters)
      );
    }
  };
}
recommendationsModule.factory('experimentationService', experimentationService);

export default experimentationService;
